module.exports = __webpack_public_path__ + "static/media/6_5.103df6b1.png";